import PropTypes from 'prop-types';
import React from 'react';
import ReactSelect from 'components/StyledSelect/react_select';
import ItemEvents from 'components/LineItemTable/itemEvents';
import { EditableTableRow, EditableTableCell } from 'components/EditableTable';
import reactSelectStyles from 'components/ReactSelect/styles';
import Editable from 'mixins/editable';
import LevelerInputCell from './levelerInputCell';


class LevelerTableRow extends Editable(React.Component) {
  state = { ...this.props.levelerItem };
  bagSizeOptions = [{ value: '25', label: '25LB' }, { value: '50', label: '50LB' }];

  handleQuantityChange = option => this.setState({ quantity: option })

  handleBagSizeChange = option => this.setState({ bag_size: option.value });

  handleSave = () => this.props.onSave(this.state);

  renderLevelersCell = (label) => {
    const { bag_size = null } = this.state;
    const displayOption = bag_size ? this.bagSizeOptions.find(o => o.value === bag_size) : '';
    return (<EditableTableCell
      label={label}
      value={typeof displayOption === 'string' ? displayOption : displayOption.label}
      onChange={value => this.handleBagSizeChange(value)}
    >
      <ReactSelect
        name="Levelers"
        className={reactSelectStyles.levelerSelectWrapper}
        value={this.state.bag_size}
        options={this.bagSizeOptions}
        placeholder="Select size"
      />
    </EditableTableCell>);
  }


  render = () => {
    const levelerItem = this.state;
    const rowProps =
      { isNew: levelerItem.id < 0,
        onSave: this.handleSave,
        onDelete: this.showDeleteDialog };
    return (<EditableTableRow key={levelerItem.id} id={levelerItem.id} {...rowProps}>
      <ItemEvents
        display={!this.context.isEditable}
        label=""
        itemType="levelers"
        dataKeys={['bag_size', 'quantity']}
        levelerItem={levelerItem}
        levelerEvents
      />
      {this.renderLevelersCell('Bag size')}
      <LevelerInputCell
        attr="quantity"
        label="Quantity"
        levelerItems={this.state}
        className={reactSelectStyles.levelerSelectWrapper}
        placeholder="Select size"
        cellValue={this.state.quantity || ''}
        onChange={event => this.handleQuantityChange(event.target.value)}
      />
    </EditableTableRow>);
  }
}

LevelerTableRow.contextTypes = { isEditable: PropTypes.bool };

LevelerTableRow.propTypes = {
  levelerItem: PropTypes.object.isRequired,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  readOnly: PropTypes.bool,
};

LevelerTableRow.defaultProps = { levelerItem: {} };

export default LevelerTableRow;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/warehouseMaterials/components/levelerTableRow.jsx